import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';
import DatePresenter from '../../presenters/DatePresenter';

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    createdAt: PropTypes.string,
  },
  {
    createdAtReadable(checkIn) {
      const createdAt = this.createdAt(checkIn);
      return DatePresenter.shortFormattedDate(createdAt);
    },
  }
);
